<template>
<div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">약재입고관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>약재명</p>
                <input type="text" placeholder="약재명을 입력하세요" class="form_control" v-model="searchInfo.medicineNm" @keyup.enter="fn_search">
              </li>
              <li>
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio" value="wrhs" checked v-model="searchInfo.chk_info">
                  <label for="radio1">입고기간</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio2" name="radio" value="expr" v-model="searchInfo.chk_info">
                  <label for="radio2">유통기한 만료</label>
                </div>
              </li>
              <li>
                  <p>입고기간</p>
                  <Datepicker v-model="searchInfo.startDt" :defaultDate="searchInfo.startDt" :format="'YYYY-MM-DD'"/> 
                  <span>~</span>
                  <Datepicker v-model="searchInfo.endDt" :defaultDate="searchInfo.endDt" :format="'YYYY-MM-DD'"/> 
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select">
<!--                <p>정렬</p>-->
<!--                <b-form-select v-model="searchInfo.orderBy">-->
<!--                  <b-form-select-option value="">전체</b-form-select-option>-->
<!--                  <b-form-select-option value="wrhsDt">입고일자</b-form-select-option>-->
<!--                </b-form-select>-->
              </div>
              <button class="btn btn_md btn_darkblue" @click="fn_move_reg_page">신규 등록</button>
            </div>
            <table class="list">
              <colgroup>
                <col width="300">
              </colgroup>
              <thead>                  
                <tr>
                    <th>입고일자</th>
                    <th>약재명</th>
                    <th>원산지</th>
                    <th>규격여부</th>
                    <th>제약회사</th>
                    <th>입고량</th>
                    <th>입고단가</th>
                    <th>유통기한</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="medWhrsList.length == 0">
                    <td colspan="10"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in medWhrsList" :key="index" @click="fn_move_dtl_page(item.med_wrhs_cd)">
                  <td><span>{{ formatDate_YYYYMMDD(item.wrhs_dt) }}</span></td>
                  <td class="al"><span>{{ item.med_hrb_nm }}</span></td>
                  <td><span>{{ item.org_plce_nm }}</span></td>
                  <td><span>{{ item.standard_yn }}</span></td>
                  <td><span>{{ item.companyNm }}</span></td>
                  <td><span>{{ item.wrhs_qnty }}</span></td>
                  <td><span>{{ formatPrice(item.wrhs_price) }}</span></td>
                  <td><span>{{ formatDate_YYYYMMDD(item.expr_dt) }}</span></td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo=searchInfo.pageInfo @clickPage="moveGrpPage" v-show="pagingShow"/>
          </div>
        </section>
      </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import Pagination from "@/components/AdminPagination.vue"
    import Datepicker from '@/components/Datepicker.vue'
    import commonUtil from "@/mixin/commonUtil";

export default {
    name: 'MedicineWrhsMngt',
    mixins: [commonUtil],
    components: {
      Pagination,
      Datepicker,
    },
    data() {
      return {
        searchInfo : {
            medicineNm : '',
            chk_info : 'wrhs',
            startDt : '',
            endDt : '',
            pageInfo : {
              page : '1',
              pageSize : '10',
              totPage : '0'
            } 
        },
        pagingShow : false,
        medWhrsList: [],
        selected: null
      }
    },
    async created(){

      let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
      if(searchInfoStore != null && searchInfoStore != {}){
          this.searchInfo = searchInfoStore;
      }
    },
    mounted(){          
        this.fn_search();
    },
    methods : {
        fn_move_reg_page(){
            this.$router.push("/admin/medicine/MedicineWrhsMngtReg");
        },
        fn_search(){

            this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

            axios
                .post("/api/medicineWrhs/searchMedicineWrhs", this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.medWhrsList = res.data.medWrhsInfo;

                    console.log("@@@@ medWhrsList : %o",this.medWhrsList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;
                
                    if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;                          
                    }    
                })
                .catch((err) => console.log(err));
            
        },
        moveGrpPage(page){
            this.searchInfo.pageInfo.page = page;
            this.fn_search();
        },
        fn_move_dtl_page(code){
            console.log("@@@@ MedWhrsCd : "+code);
            this.$store.dispatch('medWrhs/setMedWhrsCd', code); 
            this.$router.push({ name : 'MedicineWrhsMngtDtl'});
        },
    }   
  }
</script>